import BrandLogo from "../../utils/brands/BrandLogo.jsx";
import React, {useMemo} from "react";
import Tooltip from "../Tooltip.jsx";
import {useTranslation} from "react-i18next";
import {useMarketingColumns} from "../../pages/dashboard/MarketingChannelGrids/channelGridColumnSetup.js";

export default function GridSection({brand, title, children, gridType}) {
    let {t} = useTranslation();

    let columns = useMarketingColumns(gridType);

    let tooltipContent = useMemo(
        () => {
            let generalTooltip = '';

            if (brand?.isAdSystem) {
                generalTooltip = t('tooltip.channel.general');
                if (brand?.slug === 'google') {
                    generalTooltip += ' ' + t('tooltip.channel.pmax');
                }
            }

            generalTooltip += '<br><br>' + t('tooltip.column.names') + ':<br><br><table>';

            // noinspection HtmlUnknownAttribute
            let tableRow = (short, long) => '<tr class="border-b-8 border-transparent">' +
                '<td class="text-right w-24">' + short + '</td>' +
                '<td class="px-2"> - </td>' +
                '<td class="w-64">' + long + '</td>' +
                '</tr>';

            for (let column of columns) {
                if (column.desc) {
                    generalTooltip += tableRow(column.header, column.desc);
                }
            }

            generalTooltip += '</table>';

            return generalTooltip;
        },
        [brand, gridType],
    );

    return <div
        className={
            'comp__roundedBox w-full mb-5' + ' ' +
            'bg-white dark:bg-slate-800' + ' ' +
            'border-slate-200 dark:border-slate-700' + ' ' +
            'text-slate-500 hover:text-slate-600 dark:text-slate-400 dark:hover:text-slate-300' + ' ' +
            'shadow-xl rounded-md border-1'
        }>
        <div
            className={'flex gap-3 px-5 py-4 border-b border-slate-100 dark:border-slate-700 items-center'}>
            {brand && <BrandLogo brand={brand} size={6}/>}
            <h2 className={'text-lg font-semibold text-gray-800 dark:text-gray-100 flex gap-2'}>
                {title}
                {tooltipContent && (
                    <Tooltip bg="dark" size="lg" className="inline-flex" position={'bottom'}>
                        <div className="text-xs text-gray-200" dangerouslySetInnerHTML={{__html: tooltipContent}}></div>
                    </Tooltip>
                )}
            </h2>
        </div>
        <div className={'datagrid-wrap rounded-b-[12px] overflow-hidden'}>
            {children}
        </div>
    </div>;
}
